class SoundService {
  private initialized = false;

  constructor() {
    // Initialize without actual sound loading for now
    this.initialized = true;
  }

  playLevelUp(): void {
    // Placeholder for level up sound
    console.log('Level up sound would play here');
  }

  playPurchase(): void {
    // Placeholder for purchase sound
    console.log('Purchase sound would play here');
  }

  playClick(): void {
    // Placeholder for click sound
    console.log('Click sound would play here');
  }

  playError(): void {
    // Placeholder for error sound
    console.log('Error sound would play here');
  }
}

export const soundService = new SoundService();